module.exports = __webpack_public_path__ + "static/media/Великанов_Хуан Жуй_ (ДУ).44d667b7.pdf";